import { can } from '../../../permissions';
import PortalFieldHelp from './PortalFieldHelp';
import ReviewDecisionModal from './ReviewDecisionModal';

import PortalButton from './PortalButton';
import React, { useState } from 'react';
import { saveAs } from 'file-saver';
import { MdDownload, MdEdit } from 'react-icons/md';
import { usePortalMutation, usePortalDownload, usePortal } from '../hooks';
import { ErrorNotice, Status } from './Feedback';
export default function AppealReview({ application, appeal }) {
  const [reviewing, setReviewing] = useState(false);
  const { user } = usePortal();
  const canDecideApplication =
    appeal.window?.type === 'application' && !!user && can(user, 'portal_inscricoes', 'edit');
  const download = usePortalDownload();
  const decision = usePortalMutation(`inscricoes/${application.id}/recursos/${appeal.id}/decisao`);
  return (
    <article className="portal-admin-document">
      <h3>{appeal.window?.title || 'Recurso'}</h3>
      <Status value={appeal.status} />
      <p className="portal-admin-prose">{appeal.message}</p>
      <div className="portal-admin-actions hidethis actions-group">
        {appeal.attachments?.map((file) => {
          const path = `inscricoes/${application.id}/recursos/${appeal.id}/anexos/${file.id}/download`;
          return (
            <PortalButton
              key={file.id}
              className="btn btn-secondary"
              disabled={download.isLoading || !download.allowed(path)}
              onClick={() =>
                download.mutate(
                  {
                    path,
                  },
                  {
                    onSuccess: (blob) => saveAs(blob, file.file_name),
                  }
                )
              }
              type="button"
            >
              <MdDownload /> {file.file_name}
            </PortalButton>
          );
        })}
      </div>
      <ErrorNotice error={download.error} />
      {appeal.response && <div className="alert alert-info">{appeal.response}</div>}
      {appeal.ontest_recurso_id || ['question', 'answer_key'].includes(appeal.window?.type) ? (
        <p>Este recurso de questão é analisado no módulo de recursos da OnTest.</p>
      ) : (
        <>
          <PortalButton
            className="btn btn-info"
            disabled={!decision.allowed}
            onClick={() => {
              decision.reset();
              setReviewing(true);
            }}
          >
            <MdEdit /> Analisar recurso
          </PortalButton>
          {reviewing && (
            <ReviewDecisionModal
              title="Analisar recurso"
              description={appeal.window?.title}
              mutation={decision}
              onClose={() => setReviewing(false)}
              options={[
                ['approved', 'Deferir'],
                ['rejected', 'Indeferir'],
                ['answered', 'Responder sem decisão de deferimento'],
              ]}
              defaultStatus={
                ['answered', 'approved', 'rejected'].includes(appeal.status)
                  ? appeal.status
                  : 'approved'
              }
              defaultReason={appeal.response || ''}
              reasonName="response"
              reasonLabel="Resposta ao candidato"
              minLength={5}
              maxLength={20000}
              submitText="Salvar resposta"
            >
              {canDecideApplication && (
                <label className="form-label">
                  <span className="portal-field-label">
                    Situação da inscrição
                    <small className="text-muted">(opcional)</small>
                    <PortalFieldHelp label="Situação da inscrição">
                      Além de responder ao recurso, você pode deferir ou indeferir a inscrição do
                      candidato. Manter a situação atual altera apenas o recurso. O deferimento
                      exige a aprovação dos documentos obrigatórios.
                    </PortalFieldHelp>
                  </span>
                  <select
                    name="application_status"
                    className="form-control form-select"
                    defaultValue=""
                  >
                    <option value="">Manter situação atual</option>
                    <option value="approved">Deferir inscrição</option>
                    <option
                      value="rejected"
                      disabled={['synced', 'processing'].includes(application.integration_status)}
                    >
                      Indeferir inscrição
                    </option>
                  </select>
                  {['synced', 'processing'].includes(application.integration_status) && (
                    <small className="text-muted">
                      Inscrições vinculadas à prova não podem ser indeferidas pelo portal.
                    </small>
                  )}
                </label>
              )}
            </ReviewDecisionModal>
          )}
        </>
      )}
    </article>
  );
}
